import { render, staticRenderFns } from "./DpaModuleLayout.vue?vue&type=template&id=dc8cdb30&"
import script from "./DpaModuleLayout.vue?vue&type=script&lang=js&"
export * from "./DpaModuleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports